var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnChanges, SimpleChanges } from '@angular/core';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { ListingCategory } from '../../../classes/enums';
import { RowTitleBoard } from '../../../app-config.constants';
var DetailSectionComponent = /** @class */ (function (_super) {
    __extends(DetailSectionComponent, _super);
    function DetailSectionComponent(communicationService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.rows = [];
        _this.hideTitle = false;
        _this.sectionTitle = '';
        _this.hasNonEmptyRows = true;
        _this.RowTitleBoard = RowTitleBoard;
        _this.ListingCategory = ListingCategory;
        return _this;
    }
    DetailSectionComponent.prototype.ngOnChanges = function (s) {
        if (s.rows)
            this.setHasNonEmptyRows();
        this.updateListingCategory();
        this.setIsListing();
    };
    DetailSectionComponent.prototype.updateListingCategory = function () {
        if (this.previousRenderListingCategory !== this.listingCategory) {
            if (this.listingCategory === ListingCategory.COMMERCIAL) {
                this.isCommercial = true;
            }
            else if (this.listingCategory === ListingCategory.LUXURY) {
                this.isLuxury = true;
            }
            else {
                this.isResidential = true;
            }
            this.previousRenderListingCategory = this.listingCategory;
        }
    };
    DetailSectionComponent.prototype.trackBy = function (index, elem) {
        return elem.id;
    };
    DetailSectionComponent.prototype.setHasNonEmptyRows = function () {
        this.hasNonEmptyRows = this.rows && this.rows.some(function (d) { return !!d.value || !!d.default; });
    };
    DetailSectionComponent.prototype.setIsListing = function () {
        this.isListing = typeof this.listingCategory !== 'undefined';
    };
    return DetailSectionComponent;
}(HasSubscriptions));
export { DetailSectionComponent };
// If row has no data and should not show 'N/A', hide it
var DetailStub = /** @class */ (function () {
    function DetailStub(data) {
        this.id = '' + Date.now() + Math.floor(Math.random() * 1000); // Generate random id
        Object.assign(this, data);
    }
    return DetailStub;
}());
export { DetailStub };
